export default __webpack_public_path__ + "static/swirlpendantfront-63fbdb050e902a53f0006b9574c0ae0f.png";